import React from "react";
import Home from "./Home";
import { Route, Routes } from "react-router-dom";
import About from './Pages/About';
import Services from './Pages/Services';
import Work from './Pages/Work';
import Education from './Pages/Education';
import Blog from './Pages/Blog';
import Form from './Pages/Form';


const App = () => {
    return ( 
      <>
      <Routes>
  <Route exact path="/" element={<Home />}></Route>
  <Route path="/about" element={<About />}></Route>
  <Route path="/services" element={<Services />}></Route>
  <Route path="/work" element={<Work />}></Route>
  <Route path="/experience" element={<Education />}></Route>
  <Route path="/blog" element={<Blog />}></Route>
  <Route path="/contact" element={<Form />}></Route>
  </Routes>
      </>
    );
}

export default App;